export default () => ({
  statistics: [],
  errors: {}
})



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/overview/resources/data.js